import { render, staticRenderFns } from "./RegionsContractsModal.vue?vue&type=template&id=188cba2d"
import script from "./RegionsContractsModal.vue?vue&type=script&lang=js"
export * from "./RegionsContractsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports